import { ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';
import { DropdownTriggerDirective } from './dropdown-trigger.directive';

@Component({
  selector: 'mtg-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuComponent {
  @ViewChild('content', { read: TemplateRef })
  templateRef;
  trigger: DropdownTriggerDirective;

  hide(): void {
    if (this.trigger) {
      this.trigger.hideMenu();
    }
  }
}
